<template>
  <div class="layout">
    <Layout>
      <Header class="layout-header-bar" style="padding: 0 30px;">
        <RadioGroup v-model="border">
          <span @click="device">
            <Radio label="搜索传感器" border></Radio>
          </span>
          <span @click="properties">
            <Radio label="传感器属性" border></Radio>
          </span>
          <Radio label="传感器数据" border></Radio>
        </RadioGroup>
      </Header>
      <Content :style="{margin: '20px', background: '#fff', minHeight: '220px'}">
        <div style="margin:10px;text-algin:center;">
          <Card>
            <div style="width:94%;">
              <div id="main" style="width: 100%;height:360px; box-sizing border-box"></div>
            </div>
          </Card>
        </div>
        <Card style="margin:10px;">
          <Table :columns="columns8" :data="data7" ref="table" style="width:100%;"></Table>
          <br />
          <Button type="primary" size="large" @click="onExportData(1)">
            <Icon type="ios-download-outline"></Icon>导出原始数据
          </Button>
          <Button type="primary" size="large" @click="onExportData(2)" style="margin:0 10px 0 10px ;">
            <Icon type="ios-download-outline"></Icon>导出排序和过滤后的数据
          </Button>
          <Button type="primary" size="large" @click="onExportData(3)">
            <Icon type="ios-download-outline"></Icon>导出自定义数据
          </Button>
        </Card>
      </Content>
    </Layout>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      //radio的值
      border: "传感器数据",
      //通道数据的头
      columns8: [
        {
          title: "时间",
          key: "name",
          fixed: "left",
          width: 200
        },
        {
          title: "时间",
          key: "show",
          sortable: true,
          filters: [
            {
              label: "Greater than 4000",
              value: 1
            },
            {
              label: "Less than 4000",
              value: 2
            }
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            if (value === 1) {
              return row.show > 4000;
            } else if (value === 2) {
              return row.show < 4000;
            }
          }
        },
        {
          title: "Y值",
          key: "weak",
          sortable: true
        },
        {
          title: "Z值",
          key: "signin",
          sortable: true
        },
        {
          title: "单位",
          key: "click",
          sortable: true
        }
      ],
      //通道数据的数据
      data7: [
        {
          name: "2019-11-26 10:00",
          fav: 0,
          show: 7302,
          weak: 5627,
          signin: 1563,
          click: 4254
        },
        {
          name: "Name2",
          fav: 0,
          show: 4720,
          weak: 4086,
          signin: 3792,
          click: 8690
        },
        {
          name: "Name3",
          fav: 0,
          show: 7181,
          weak: 8007,
          signin: 8477,
          click: 1879
        },
        {
          name: "Name4",
          fav: 0,
          show: 9911,
          weak: 8976,
          signin: 8807,
          click: 8050
        },
        {
          name: "Name5",
          fav: 0,
          show: 934,
          weak: 1394,
          signin: 6463,
          click: 5278
        }
      ]
    };
  },
  methods: {
    //搜索通道的跳转
    device() {
      this.$router.replace({ name: "index_channel" });
    },
    //通道属性的跳转
    properties() {
      this.$router.replace({ name: "channel_properties" });
    },
    //导出数据
    onExportData(type) {
      if (type === 1) {
        this.$refs.table.exportCsv({
          filename: "原始数据"
        });
      } else if (type === 2) {
        this.$refs.table.exportCsv({
          filename: "整理和过滤数据",
          original: false
        });
      } else if (type === 3) {
        this.$refs.table.exportCsv({
          filename: "自定义数据",
          columns: this.columns8.filter((col, index) => index < 4),
          data: this.data7.filter((data, index) => index < 4)
        });
      }
    }
  },
  mounted() {
    var a = 0;
    var b = 200;
    var myChart = echarts.init(document.getElementById("main"));
    // 指定图表的配置项和数据
    var option = {
      color: ["red", "#000"],
      title: {
        text: "",
        x: "center",
        align: "left"
      },
      grid: {
        left: "60px"
      },
      // toolbox: {
      //   feature: {
      //     dataZoom: {
      //       yAxisIndex: "none"
      //     },
      //     restore: {},
      //     saveAsImage: {}
      //   }
      // },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          animation: false
        }
      },
      // legend: {

      // selectedMode:false,//取消图例上的点击事件

      // // data:['11111',]

      // },
      dataZoom: [
        {
          type: "inside",
          realtime: true,
          start: 10,
          end: 50
        }
      ],
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          axisLine: { onZero: false },
          data: [
            "2009/6/12 2:00",
            "2009/6/12 3:00",
            "2009/6/12 4:00",
            "2009/6/12 5:00",
            "2009/6/12 6:00",
            "2009/6/12 7:00",
            "2009/6/12 8:00",
            "2009/6/12 9:00",
            "2009/6/12 10:00",
            "2009/6/12 11:00",
            "2009/6/12 12:00",
            "2009/6/12 13:00",
            "2009/6/12 14:00",
            "2009/6/12 15:00",
            "2009/6/12 16:00",
            "2009/6/12 17:00",
            "2009/6/12 18:00",
            "2009/6/12 19:00",
            "2009/6/12 20:00",
            "2009/6/12 21:00",
            "2009/6/12 22:00",
            "2009/6/12 23:00",
            "2009/6/13 0:00",
            "2009/6/13 1:00",
            "2009/6/13 2:00",
            "2009/6/13 3:00",
            "2009/6/13 4:00",
            "2009/6/13 5:00",
            "2009/6/13 6:00",
            "2009/6/13 7:00",
            "2009/6/13 8:00",
            "2009/6/13 9:00",
            "2009/6/13 10:00",
            "2009/6/13 11:00",
            "2009/6/13 12:00",
            "2009/6/13 13:00",
            "2009/6/13 14:00",
            "2009/6/13 15:00",
            "2009/6/13 16:00",
            "2009/6/13 17:00",
            "2009/6/13 18:00",
            "2009/6/13 19:00",
            "2009/6/13 20:00",
            "2009/6/13 21:00",
            "2009/6/13 22:00",
            "2009/6/13 23:00",
            "2009/6/14 0:00",
            "2009/6/14 1:00",
            "2009/6/14 2:00",
            "2009/6/14 3:00",
            "2009/6/14 4:00",
            "2009/6/14 5:00",
            "2009/6/14 6:00",
            "2009/6/14 7:00",
            "2009/6/14 8:00",
            "2009/6/14 9:00",
            "2009/6/14 10:00",
            "2009/6/14 11:00",
            "2009/6/14 12:00",
            "2009/6/14 13:00",
            "2009/6/14 14:00",
            "2009/6/14 15:00",
            "2009/6/14 16:00",
            "2009/6/14 17:00",
            "2009/6/14 18:00",
            "2009/6/14 19:00",
            "2009/6/14 20:00",
            "2009/6/14 21:00",
            "2009/6/14 22:00",
            "2009/6/14 23:00",
            "2009/6/15 0:00",
            "2009/6/15 1:00",
            "2009/6/15 2:00",
            "2009/6/15 3:00",
            "2009/6/15 4:00",
            "2009/6/15 5:00",
            "2009/6/15 6:00",
            "2009/6/15 7:00",
            "2009/6/15 8:00",
            "2009/6/15 9:00",
            "2009/6/15 10:00",
            "2009/6/15 11:00",
            "2009/6/15 12:00",
            "2009/6/15 13:00",
            "2009/6/15 14:00",
            "2009/6/15 15:00",
            "2009/6/15 16:00",
            "2009/6/15 17:00",
            "2009/6/15 18:00",
            "2009/6/15 19:00",
            "2009/6/15 20:00",
            "2009/6/15 21:00",
            "2009/6/15 22:00",
            "2009/6/15 23:00",
            "2009/6/15 0:00",
            "2009/6/16 1:00",
            "2009/6/16 2:00",
            "2009/6/16 3:00",
            "2009/6/16 4:00",
            "2009/6/16 5:00",
            "2009/6/16 6:00",
            "2009/6/16 7:00",
            "2009/6/16 8:00",
            "2009/6/16 9:00",
            "2009/6/16 10:00",
            "2009/6/16 11:00",
            "2009/6/16 12:00",
            "2009/6/16 13:00",
            "2009/6/16 14:00",
            "2009/6/16 15:00",
            "2009/6/16 16:00",
            "2009/6/16 17:00",
            "2009/6/16 18:00",
            "2009/6/16 19:00",
            "2009/6/16 20:00",
            "2009/6/16 21:00",
            "2009/6/16 22:00",
            "2009/6/16 23:00",
            "2009/6/15 0:00",
            "2009/6/17 1:00",
            "2009/6/17 2:00",
            "2009/6/17 3:00",
            "2009/6/17 4:00",
            "2009/6/17 5:00",
            "2009/6/17 6:00",
            "2009/6/17 7:00",
            "2009/6/17 8:00",
            "2009/6/17 9:00",
            "2009/6/17 10:00",
            "2009/6/17 11:00",
            "2009/6/17 12:00",
            "2009/6/17 13:00",
            "2009/6/17 14:00",
            "2009/6/17 15:00",
            "2009/6/17 16:00",
            "2009/6/17 17:00",
            "2009/6/17 18:00",
            "2009/6/17 19:00",
            "2009/6/17 20:00",
          ].map(function(str) {
            return str.replace(" ", "\n");
          })
        }
      ],
      yAxis: [
        {
          name: "流量(m^3/s)",
          type: "value",
          max: 500
        }
      ],
      visualMap: [
        {
          show: false,
          seriesIndex: 0,
          pieces: [
            {
              gt: a,
              lte: b,
              color: "#000"
            },
            {
              gt: b,
              color: "red"
            }
          ]
        }
      ],
      series: [
        {
          name: "11111",
          type: "line",
          animation: false,
          data: [
            44.64,
            46.74,
            47.5,
            46.86,
            45.16,
            42.77,
            40.04,
            37.33,
            35,
            32.74,
            30.21,
            27.7,
            25.5,
            23.9,
            23.2,
            23.06,
            22.94,
            22.84,
            22.77,
            22.72,
            22.7,
            22.8,
            23.23,
            23.95,
            24.91,
            26.04,
            27.3,
            28.76,
            30.7,
            33.39,
            37.12,
            42.15,
            48.77,
            65.22,
            252.1,
            257,
            237.32,
            221.19,
            212,
            208.67,
            206.89,
            205.2,
            202.15,
            189.82,
            172,
            165.3,
            160.49,
            156.8,
            153.44,
            149.62,
            144.6,
            138.27,
            131,
            123.11,
            114.9,
            106.69,
            98.79,
            91.5,
            85.13,
            80,
            75.53,
            71.03,
            66.65,
            62.54,
            58.85,
            55.73,
            53.31,
            51.75,
            51.2,
            56.53,
            68.25,
            80,
            91.01,
            102.03,
            109,
            112.37,
            115.29,
            117.68,
            119.48,
            120.61,
            121,
            119.45,
            115.57,
            110.52,
            105.47,
            101.58,
            100,
            99.97,
            99.94,
            99.92,
            99.9,
            99.88,
            99.86,
            99.85,
            99.84,
            99.83,
            99.82,
            99.81,
            99.81,
            99.8,
            99.8,
            99.8,
            122.15,
            163.65,
            186,
            182.96,
            175.15,
            164.56,
            153.18,
            143,
            136,
            131.37,
            126.98,
            122.81,
            118.85,
            115.09,
            111.52,
            108.13,
            104.9,
            101.83,
            98.9,
            96.11,
            93.44,
            90.87,
            88.41,
            86.04,
            83.74,
            81.51,
            79.33,
            77.2,
            75.1,
            73.02,
            70.95,
            68.88,
            66.8,
            64.87,
            63.14,
            61.4,
            59.53,
            57.67,
            56,
            54.6,
            53.36,
            52.2,
            51.05,
            49.85,
            48.5,
            46.87,
            44.92,
            42.74,
            40.42,
            38.04,
            35.69,
            33.46,
            31.44,
            29.72,
            28.38,
            27.51,
          ]
        }
      ]
    };

    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
    // window.onresize = myChart.resize;
    window.onresize = function() {
      myChart.resize();
    };
  },
  created() {
    //判断通道属性的ID
   
    if (this.$route.params.id == "-1") {
      this.$Message["warning"]({
        content: "请返回传感器索引，选择传感器",
        duration: 3
      });
      setTimeout(() => {
        this.$router.push({
          path: `/device_management/index_sensor`
        });
      }, 3000);
    }
  },
  watch: {
    '$route.params.id'(newval,oldval){
      this.new()
    }
  },
  computed: {}
};
</script>
<style scoped>
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
.tree {
  margin: 20px;
}
.con-header {
  margin: 10px;
}
.con-header > button {
  float: right;
}
.con-min {
  margin: 10px;
}
.hear {
  text-align: center;
  background-color: #3684e1;
  color: #fff;
}
.middle {
  margin: 13%;
  /* 水平垂直居中
    position: absolute;
    top:50%;
    left:50%; 
    transform: translate(-50%,-50%); */
}
</style>